import { NgModule } from '@angular/core';
import { ngMaterialImports } from './ng-material.imports';
import { ngxImports } from './ngx.imports';



@NgModule({
  exports: [...ngMaterialImports, ...ngxImports]
})
export class ThirdLibModule { }
